import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from "../user/user.service";
import { Alert } from "../alert/alert";

@Component({
  selector: 'app-user-manager',
  templateUrl: './user-manager.component.html',
  styleUrls: ['./user-manager.component.css']
})
export class UserManagerComponent implements OnInit {

  public users:Array<any>;
  public alert:Alert = new Alert('hide', '', '');
  public modalState:string = 'hide';

  constructor(private userService:UserService,
              private router:Router) {
  }

  ngOnInit() {
    this.getAllUsers();
  }

  public deleteUser(user) {
    this.userService.deleteUser(user)
      .subscribe(suc => {
          this.alert.update('show', 'alert-success', 'Nutzer wurde gelöscht');
          setTimeout(() => this.alert.state = 'hide', 4000);
          this.getAllUsers();
        },
        err => {
          if (err.status == 400) {
            this.alert.update('show', 'alert-danger', 'Es ist nicht möglich Ihren eigenen Account zu löschen');
            setTimeout(() => this.alert.state = 'hide', 4000);
          }
        });
  }

  public getAllUsers():void {
    this.userService.getAllUsers()
      .subscribe(users => {
          this.users = users;
        },
        err => {
          if (err.status == 403) {
            this.router.navigate(['login']);
          } else {
            this.alert.update('show', 'alert-danger', 'Nutzer konnten nicht geladen werden');
            setTimeout(() => this.alert.state = 'hide', 4000);
          }
        });
  }

  public updateAlert(alert):void {
    this.alert = alert;
    setTimeout(() => this.alert.state = 'hide', 4000);
  }

}



// WEBPACK FOOTER //
// ./src/app/user-manager/user-manager.component.ts